import React, { useRef, useState, useEffect } from 'react';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { googleClickTabEvent } from '../../../../utils/analytics';
import { windowService } from '../../../../utils/window.utils';
import CarouselArrow from '../../../@shared/carouselArrow';

const CompatibleLoadersTabs = ({ tabs, selectedTab, onSelect }): JSX.Element => {
  const tabContainerEl = useRef<HTMLDivElement | null>(null);
  const [hideArrows, setHideArrows] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    function resizeHandler(): void {
      onSelect(0);
    }

    resizeHandler();

    windowService().addEventListener('resize', resizeHandler);
    return (): void => windowService().removeEventListener('resize', resizeHandler);
  }, [tabContainerEl, windowService]); // eslint-disable-line

  useEffect(() => {
    if (tabContainerEl?.current) {
      const tabContainerDim = tabContainerEl.current.getBoundingClientRect();
      const tabChildrens = tabContainerEl.current.children;
      if (tabChildrens?.length) {
        const lastChild = tabChildrens[tabChildrens.length - 1];
        if (lastChild) {
          const lastChildDim = lastChild.getBoundingClientRect();
          if (tabContainerDim.left > 0 && lastChildDim.right - tabContainerDim.right < 0) {
            tabContainerEl.current.style.justifyContent = 'flex-start';
            setHideArrows(true);
          }
        }
      }
    }
  }, [tabContainerEl, selectedTab, tabs]);

  const scrollTab = (direction: string): void => {
    if (tabContainerEl?.current) {
      const tabChildren = tabContainerEl.current.children[0];
      const tabDimension = tabChildren.getBoundingClientRect().width;

      if (direction === 'right') {
        tabContainerEl.current.style.right = `${+tabContainerEl.current.style.right.split('p')[0] + tabDimension}px`;
        setShowLeftArrow(true);
        if (+tabContainerEl.current.style.right.split('p')[0] > tabContainerEl.current.scrollWidth - tabContainerEl.current.offsetWidth) {
          tabContainerEl.current.style.right = `${tabContainerEl.current.scrollWidth - tabContainerEl.current.offsetWidth}px`;
          setShowRightArrow(false);
        }
      } else {
        tabContainerEl.current.style.right = `${+tabContainerEl.current.style.right.split('p')[0] - tabDimension}px`;
        setShowRightArrow(true);
        if (+tabContainerEl.current.style.right.split('p')[0] < 0) {
          tabContainerEl.current.style.right = '0px';
          setShowLeftArrow(false);
        }
      }
    }
  };

  useEffect(() => {
    if (isMobile || hideArrows) return;
  }, [tabContainerEl, selectedTab, tabs, isMobile]); // eslint-disable-line

  const goToPreviousSlide = (): void => {
    scrollTab('left');
  };

  const goToNextSlide = (): void => {
    scrollTab('right');
  };

  return (
    <div className={'product-compatible-loaders-listing__tabs-container'}>
      <section className={'product-compatible-loaders-listing__tabs'}>
        <div className="product-compatible-loaders-listing__slider-wrapper" ref={tabContainerEl}>
          {tabs.map((tab, index: number) => (
            <h3
              key={tab?.id}
              onClick={(): void => {
                onSelect(index);
                googleClickTabEvent('Select', tab?.title, index + 1);
              }}
              className={`product-compatible-loaders-listing__tab ${
                index === selectedTab ? 'product-compatible-loaders-listing__tab--selected' : ''
              }`}
            >
              {tab.title}
            </h3>
          ))}
        </div>
        {tabs && tabs.length > 9 && (
          <>
            <CarouselArrow
              className={`
                            product-compatible-loaders-listing__arrow
                        product-compatible-loaders-listing__arrow--left
                            ${isMobile || hideArrows || !showLeftArrow ? 'product-compatible-loaders-listing__arrow--hide' : ''}
                                    `}
              direction="previous"
              onClick={goToPreviousSlide}
            />
            <CarouselArrow
              className={`
            product-compatible-loaders-listing__arrow
            product-compatible-loaders-listing__arrow--right
            ${isMobile || hideArrows || !showRightArrow ? 'product-compatible-loaders-listing__arrow--hide' : ''}
          `}
              direction="next"
              onClick={goToNextSlide}
            />
          </>
        )}
      </section>
    </div>
  );
};

export default CompatibleLoadersTabs;
